import { Component } from '@angular/core';
import { UserRoleService } from '@services/user-role.service';

@Component({
  selector: 'app-user-permission-list',
  templateUrl: './user-permission-list.component.html',
  styleUrl: './user-permission-list.component.scss'
})
export class UserPermissionListComponent {
  public roles = [];
  public totalRecords = 0;
  public loading = true;
  public userDetail : any;

  constructor(private userRoleService: UserRoleService) {}

  ngOnInit(): void {
    this.userDetail = JSON.parse(localStorage.getItem('UserDetail'));
    this.loadRolesList(this.userDetail.id);
  }

  // Load disinfection data based on pagination event
  loadRolesList(userId:any): void {
    this.loading = true;
    this.userRoleService.getUserlistCount(userId).subscribe(response => {
      this.roles = response;
      this.loading = false;
    });
  }

}
